/*
cart
minicart
AT
17.09.20
*/

import Cart from './cart.svelte'
import Minicart from './minicart.svelte'

const
cart = new Cart({
	target: document.querySelector('#cart'),
	props: { }
}),

minicart = new Minicart({
	target: document.querySelector('#minicart'),
	props: { }
})

export default { cart, minicart }